
import { getViewApi } from "../callApi/view";
import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

export default function CustomBottom() {
  const [view, setview] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res = await getViewApi();
    if (res?.status == 200) {
      setview(res.data.data);
    }
  };
  return (
    <div className="w-full bg-black flex flex-col ">
      <div className="w-full  p-8 flex flex-col md:flex-row justify-around items-start gap-[30px]">
        <div className="flex flex-col items-center gap-[30px] w-full md:w-auto">
          <img
            src="/img/white logo.png"
            className="w-[300px] cursor-pointer hover:opacity-50 object-contain"
          />
          <div className="font_Kanit text-white font-bold text-[24px]">
            คิด สร้างสรรค์ พัฒนา ยั่งยืน
          </div>
          <div className="font_Kanit text-[#858485]">
            © 2024 FTCDC. All rights reserved.
          </div>
        </div>
        <div className="flex flex-col items-start gap-[30px]">
          <div className="font_Kanit text-[#B36427] font-bold text-[24px]">
            เกี่ยวกับเรา
          </div>
          <div className="font_Kanit text-white font-medium text-base">
            ศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ (FTCDC)
            <br />
            ศูนย์ปฏิบัติการทดสอบวิเคราะห์ผ้าและสิ่งทอ (FTCDC LAB)
          </div>
        </div>
        <div className="flex flex-col items-start gap-[30px] w-full sm:w-[300px]">
          <div className="font_Kanit text-[#B36427] font-bold text-[24px]">
            ติดต่อเรา
          </div>
          <div className="font_Kanit text-white font-medium text-base">
            มหาวิทยาลัยราชภัฏอุดรธานี
            <br />
            เลขที่ 64 ถนนทหาร ตำบลหมากแข้ง อำเภอเมือง
            <br />
            จังหวัดอุดรธานี 41000
            <br />
            E-mail : labftcdc@gmail.com
            <br />
            ผู้ประสานงาน : 088-7289987 (มุขรินทร์)
          </div>
          <div className="flex flex-row justify-center items-center w-full">
            <a href="https://www.facebook.com/profile.php?id=100063588970461" target="_blank" className="bg-[#1976d2] p-1 rounded-md w-full flex flex-row justify-center">
            <img src="/img/facebook.png" className="object-contain w-10" />
            </a>
          </div>
        </div>
      </div>
      <div className="text-center bg-white self-center font_Kanit font-semibold rounded-md px-2 py-1 mb-3">จำนวนผู้เข้าชม {view?.view_count ?? 0}</div>
    </div>
  );
}
